import React, {  useEffect, useContext } from 'react';
import { useThree } from '@react-three/fiber';

import { useViewerStateStore } from '../../store/viewerStateStore';
import { getLayerNames } from '../../utils/layerUtils';

const CameraLayersLogger = () => {
  const { camera } = useThree();
  const { viewerMode } = useViewerStateStore();
  
  useEffect(() => {
    // Log active layers
    console.log("Camera Layers:");
    const layerNames = getLayerNames(camera.layers);
    layerNames.forEach((layerName) => console.log(" - " + layerName));
  }, [viewerMode]);

  useEffect(() => {
    console.log(`Camera changed: ${camera.type}`);
  }, [camera]);

  return null;
};

export default CameraLayersLogger;